import { IOwner } from '@features/account/types'
import { COUNTRIES_API, getStatesApi, MY_ACCOUNT_INFO_PATH, MY_ACCOUNT_PASSWORD_PATH } from './MkAccountConstants'
import { serverUrl } from '@utils/MkEnv'
import { fetchApi, performRequest } from '@api/MkApi'
import { IMkChangePasswordDialogFormState } from '../components/MyAccount/MkChangePasswordDialog/MkChangePasswordDialog'
import { MkCountry, MkState } from '@typescript'
import type {
  IMkOwnerUpdateParameters,
  IMkOwnerUpdateResponse,
  IMkPasswordUpdateResponse,
} from '@account/types/editInfoForm'

/**
 * Gets account info to the backend.
 * @returns A promise that resolves the backend response.
 */
export async function getAccountInfo(authHeaders: Record<string, string>): Promise<IOwner> {
  const url = `${serverUrl}${MY_ACCOUNT_INFO_PATH}`
  return fetchApi<IOwner>(url, authHeaders)
}

/**
 * Updates account info or returns suggestions for address.
 * @returns A promise that resolves the backend response.
 */
export async function updateAccountInfo(parameters: IMkOwnerUpdateParameters, authHeaders: Record<string, string>): Promise<IMkOwnerUpdateResponse> {
  const url = `${serverUrl}${MY_ACCOUNT_INFO_PATH}`
  const body = JSON.stringify(parameters)
  return performRequest<IMkOwnerUpdateResponse>('PUT', url, body, authHeaders)
}

/**
 * Updates account info or returns suggestions for address.
 * @returns A promise that resolves the backend response.
 */
export async function updateAccountPassword(parameters: IMkChangePasswordDialogFormState, authHeaders: Record<string, string>): Promise<IMkPasswordUpdateResponse> {
  const url = `${serverUrl}${MY_ACCOUNT_PASSWORD_PATH}`
  const body = JSON.stringify(parameters)
  return performRequest<IMkPasswordUpdateResponse>('PUT', url, body, authHeaders)
}

/**
 * Gets countries.
 * @returns A promise that resolves the backend response.
 */
export async function getCountries(authHeaders: Record<string, string>): Promise<MkCountry[]> {
  const url = `${serverUrl}${COUNTRIES_API}`
  return fetchApi<MkCountry[]>(url, authHeaders)
}

/**
 * Gets states.
 * @returns A promise that resolves the backend response.
 */
export async function getStates(countryCode: string, authHeaders: Record<string, string>): Promise<MkState[]> {
  const url = `${serverUrl}${getStatesApi(countryCode)}`
  return fetchApi<MkState[]>(url, authHeaders)
}
